<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import MeasurementUnitForm from "./components/MeasurementUnitForm.vue"

defineProps<{
  measurement_unit: {
    id?: number | null
    name: string
    symbol: string
  }
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <MeasurementUnitForm
      mode="create"
      title="MeasurementUnits/MeasurementUnitsNew"
      subtitle="Cadastre unidades reutilizaveis para produtos."
      :measurement-unit="measurement_unit"
      :errors="errors"
    />
  </AppShell>
</template>

